import React, { Fragment } from 'react';
import { SBox } from '@avalara/skylab-sdk/react';
import styled from 'styled-components';
import { COLORS } from '@avalara/bat-apps-shared/lib/constants';
import { datesToRememberText } from '../constants';
const Wrapper = styled.div `
  display: inline-block;
  h2 {
    font-size: 23px;
    line-height: 30px;
  }
  p {
    color: ${COLORS.grayBlack};
    font-size: 18px;
    line-height: 24px;
  }
`;
const DatesToRemember = () => {
    const { headingText, bullets } = datesToRememberText();
    return (React.createElement(Wrapper, null,
        React.createElement(SBox, { className: 'secondary pad-all-md pad-right-lg' },
            React.createElement("h2", { "data-ref": 'buy.returns-thankyou.reminders.header' }, headingText),
            bullets.map(({ dateRange, text, textSecondLine }, i) => React.createElement(Fragment, { key: i },
                React.createElement("p", { "data-ref": `buy.returns-thankyou.reminders.${i}-dateRange`, className: 'font-bold pad-top-sm' }, dateRange),
                React.createElement("p", { "data-ref": `buy.returns-thankyou.reminders.${i}-text`, className: 'pad-top-xs' }, text),
                React.createElement("p", { "data-ref": `buy.returns-thankyou.reminders.${i}-textSecondLine`, className: 'pad-top-xs' }, textSecondLine))))));
};
export default DatesToRemember;
